// frontend/src/components/capacitor/CapacitorHome.tsx
import { useRef, useState } from 'react'
import { CapacitorFeaturesDrawer } from './CapacitorFeaturesDrawer'
import './Capacitor.css'

interface Props {
  onFile: (file: File) => void
}

function openUrl(url: string) {
  window.open(url, '_system')
}

export function CapacitorHome({ onFile }: Props) {
  const inputRef = useRef<HTMLInputElement>(null)
  const [featuresOpen, setFeaturesOpen] = useState(false)

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) onFile(file)
  }

  return (
    <div className="cap-home">
      <div className="cap-home-logo">💬</div>
      <h1 className="cap-home-title">WhatsApp Chat sichern</h1>
      <p className="cap-home-subtitle">Als PDF archivieren — dauerhaft &amp; durchsuchbar</p>

      <div className="cap-steps">
        <div className="cap-step">
          <div className="cap-step-num">1</div>
          <div className="cap-step-text">
            <strong>WhatsApp öffnen</strong> und den Chat antippen, den du archivieren möchtest.
          </div>
        </div>
        <div className="cap-step">
          <div className="cap-step-num">2</div>
          <div className="cap-step-text">
            Tippe auf ··· oben rechts → <strong>Mehr</strong> → <strong>Chat exportieren</strong> → <strong>Mit Medien</strong>.
          </div>
        </div>
        <div className="cap-step">
          <div className="cap-step-num">3</div>
          <div className="cap-step-text">
            Wähle <strong>ChatArchiv</strong> aus der Teilen-Liste — der Chat wird automatisch verarbeitet.
          </div>
        </div>
      </div>

      <div className="cap-home-pricing-hint">
        Vorschau kostenlos · PDF ab <strong>€4,99</strong>
      </div>

      <input
        ref={inputRef}
        type="file"
        accept=".zip,.txt"
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />
      <button className="cap-home-file-btn" onClick={() => inputRef.current?.click()}>
        📂 Datei direkt öffnen
      </button>

      <button className="cap-home-features-link" onClick={() => setFeaturesOpen(true)}>
        Was bekomme ich? →
      </button>

      <div className="cap-home-legal">
        <button onClick={() => openUrl('https://chatarchiv.de/datenschutz.html')}>Datenschutz</button>
        <span>·</span>
        <button onClick={() => openUrl('https://chatarchiv.de/impressum.html')}>Impressum</button>
        <span>·</span>
        <button onClick={() => openUrl('https://chatarchiv.de/agb.html')}>AGB</button>
        <span>·</span>
        <a href="mailto:support@chatarchiv.de">Kontakt</a>
      </div>

      <CapacitorFeaturesDrawer open={featuresOpen} onClose={() => setFeaturesOpen(false)} />
    </div>
  )
}
